module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    staticClass: "adviser-select",
    attrs: {
      "value": _vm.value,
      "size": _vm.size,
      "transfer": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onChange
    }
  }, [_c('Option', {
    attrs: {
      "value": "all",
      "label": "全部运营"
    }
  }, [_vm._v("全部运营（" + _vm._s(_vm.totalCount) + " 人）")]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": String(item.id),
        "label": item.nickname || '未分配'
      }
    }, [_vm._v("\n    " + _vm._s(item.nickname || '未分配') + "（" + _vm._s(item.count || 0) + " 人）\n  ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ff961f9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/AdviserSelect.vue
// module id = 1891
// module chunks = 8